import { render, staticRenderFns } from "./PublicChats.vue?vue&type=template&id=a67ab3e2&scoped=true&"
import script from "./PublicChats.vue?vue&type=script&lang=js&"
export * from "./PublicChats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67ab3e2",
  null
  
)

export default component.exports